/**
 * Draws the road layer as a light path on top of the terrain. Roads change only
 * when the player edits them, so this redraws on demand (dirty flag) rather than
 * every frame.
 */
import { Container, Graphics } from 'pixi.js';
import { gridToWorld, TILE_HALF_WIDTH, TILE_HALF_HEIGHT } from '@settlers/shared';
import type { GameMap, RoadNetwork } from '@settlers/engine';

const ROAD_COLOR = 0xcaa96b;

export class RoadRenderer {
  readonly stage = new Container();
  private readonly g = new Graphics();
  private dirty = true;

  constructor(
    private readonly map: GameMap,
    private readonly roads: RoadNetwork,
  ) {
    this.stage.addChild(this.g);
  }

  markDirty(): void {
    this.dirty = true;
  }

  redrawIfNeeded(): void {
    if (!this.dirty) return;
    this.dirty = false;
    const g = this.g;
    g.clear();
    const layer = this.roads.layer;
    const w = this.map.width;
    const sx = TILE_HALF_WIDTH * 0.62;
    const sy = TILE_HALF_HEIGHT * 0.62;
    for (let i = 0; i < layer.length; i++) {
      if (layer[i] !== 1) continue;
      const x = i % w;
      const y = (i - x) / w;
      const c = gridToWorld(x, y, this.map.elevationAt(x, y));
      g.poly([c.x, c.y - sy, c.x + sx, c.y, c.x, c.y + sy, c.x - sx, c.y]).fill({
        color: ROAD_COLOR,
        alpha: 0.85,
      });
    }
  }
}
